module.exports = __webpack_public_path__ + "static/img/bed-bedroom-bedsheet-2387753.c6af351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/bed-bedroom-bedsheet-2387753.jpg
// module id = Bz4s
// module chunks = 1